import { render } from "./Album.vue?vue&type=template&id=5b2a71f3&scoped=true"
import script from "./Album.vue?vue&type=script&lang=js"
export * from "./Album.vue?vue&type=script&lang=js"

import "./Album.vue?vue&type=style&index=0&id=5b2a71f3&scoped=true&lang=css"

import exportComponent from "D:\\Front-end\\Beetronix\\alradwan-frontend\\vue-1\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2a71f3"]])

export default __exports__